module.exports = __webpack_public_path__ + "img/melon@2x.afb4adc6.png";